import {
  DashboardIcon,
  DiscoverIcon,
  FavoritesIcon,
  // MessagesIcon,
  SettingsIcon,
  SignInIcon,
} from '../assets/icons';

export const links = [
  {
    id: 1,
    url: '/',
    text: 'Dashboard',
    isProtected: false,
    icon: <DashboardIcon />,
  },
  {
    id: 2,
    url: '/discover',
    text: 'Discover',
    isProtected: false,
    icon: <DiscoverIcon />,
  },
  // {
  //   id: 3,
  //   url: '/messages',
  //   text: 'Messages',
  //   icon: <MessagesIcon />,
  // },
  {
    id: 4,
    url: '/favorites',
    text: 'Favorites',
    isProtected: true,
    icon: <FavoritesIcon />,
  },
  {
    id: 5,
    url: '/settings',
    text: 'Settings',
    isProtected: true,
    icon: <SettingsIcon />,
  },
  {
    id: 6,
    url: '/auth',
    text: 'Sign In',
    isProtected: false,
    icon: <SignInIcon />,
  },
];
